import { useState, useEffect } from "react";
import { useMap } from "react-leaflet";

const normalize = (str = "") =>
  str.toLowerCase().replace(/\s+/g, "").trim();

export const LocationSearch = ({ setPosition }) => {
  const [query, setQuery] = useState("");
  const map = useMap();

  useEffect(() => {
    if (!query || query.length < 5) return;

    const delayDebounce = setTimeout(async () => {
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/search?` +
            `format=json` +
            `&addressdetails=1` +
            `&countrycodes=id` +
            `&viewbox=95.0,-11.0,141.0,6.0` +
            `&bounded=1` +
            `&limit=25` +
            `&q=${encodeURIComponent(query)}`
        );

        const data = await res.json();
        if (!data.length) return;

        const parts = query.split(",").map(p => normalize(p));

        let bestMatch = null;
        let bestScore = 0;

        for (const item of data) {
          const addr = item.address || {};
          let score = 0;

          if (addr.state && parts.some(p => normalize(addr.state).includes(p)))
            score += 3;

          if (addr.county && parts.some(p => normalize(addr.county).includes(p)))
            score += 3;

          if (
            (addr.city || addr.town) &&
            parts.some(p =>
              normalize(addr.city || addr.town).includes(p)
            )
          )
            score += 2;

          if (addr.suburb && parts.some(p => normalize(addr.suburb).includes(p)))
            score += 3;

          if (
            (addr.village || addr.hamlet) &&
            parts.some(p =>
              normalize(addr.village || addr.hamlet).includes(p)
            )
          )
            score += 5;

          if (score > bestScore) {
            bestScore = score;
            bestMatch = item;
          }
        }

        if (!bestMatch) return;

        const lat = parseFloat(bestMatch.lat);
        const lon = parseFloat(bestMatch.lon);

        setPosition({ lat, lng: lon });
        map.setView([lat, lon], 15);
      } catch (err) {
        console.error("Location search error:", err);
      }
    }, 800);

    return () => clearTimeout(delayDebounce);
  }, [query, map, setPosition]);

  return (
    <div
      style={{
        position: "absolute",
        top: 10,
        right: 10,
        zIndex: 1000,
        background: "white",
        padding: 10,
        borderRadius: 8,
        color: "black",
      }}
    >
      <input
        type="text"
        placeholder="Cari Lokasi"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{ padding: 6, width: 260 }}
      />
    </div>
  );
};
